import { Spin, Typography } from "antd";
import { showError } from "common/ToastNotifications";
import FlexContainerLayout from "components/atoms/FlexContainerLayout";
import LoadingOverlay from "components/atoms/LoadingOverlay";
import ProhibitedArea from "components/molecules/ProhibitedArea";
import DataSetRecentList from "components/organisms/DataSetRecentList";
import AppPaths from "constants/appPaths";
import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import actions from "store/actions";

const { Title } = Typography;

class DataSetHomeOverview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fetchingDataSets: false,
            fetchingPermission: false,
            busy: false,
            busyMessage: "Please wait...",
            refreshingDataSets: false,
        };
    }

    componentWillMount() {
        this.props.getUserDataSetPermission();
        this.props.getRecentDataSet();
        if (!this.props.recentDataSetListResult || !this.props.recentDataSetListResult.Items || this.props.recentDataSetListResult.Items.length === 0) {
            this.setState({
                fetchingDataSets: true,
                fetchingPermission: true,
            });
        } else {
            this.setState({
                refreshingDataSets: true,
            });
        }
    }

    componentDidMount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.onGetUserDataSetPermissionResultChanged(prevProps);
        this.onGetRecentDataSetResultChanged(prevProps);
        this.onRecentDataSetListResultChanged(prevProps);
    }

    componentWillUnmount() {
        // Deselect DataSet before dismounting
        this.props.onDataSetSelected(null);
    }

    onGetUserDataSetPermissionResultChanged = (prevProps) => {
        if (this.props.getUserDataSetPermissionResult && this.props.getUserDataSetPermissionResult !== prevProps.getUserDataSetPermissionResult) {
            if (!this.props.getUserDataSetPermissionResult.success) {
                this.setState({
                    permissionDenied: true,
                });
            }
            this.setState({
                fetchingPermission: false,
            });
        }
    };

    onGetRecentDataSetResultChanged = (prevProps) => {
        if (this.props.getRecentDataSetResult && this.props.getRecentDataSetResult !== prevProps.getRecentDataSetResult) {
            if (!this.props.getRecentDataSetResult.success) {
                if (this.props.getRecentDataSetResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        permissionDenied: true,
                    });
                } else {
                    showError("Unable to retrieve dataset at this moment.");
                }
            }
            this.setState({
                fetchingDataSets: false,
                refreshingDataSets: false,
            });
        }
    };

    onRecentDataSetListResultChanged = (prevProps) => {
        if (this.props.recentDataSetListResult && this.props.recentDataSetListResult !== prevProps.recentDataSetListResult) {
            if (this.state.selectedDataSetId) {
                this.props.onDataSetSelected && this.props.onDataSetSelected(this.state.selectedDataSetId);
            }
        }
    };

    showViewDataSet = (dataSet) => {
        this.props.history.push(
            AppPaths.TENANT_SCHEMA_DATASET_ID_ACTION.replace(":tenant", this.props.tenant.toLowerCase())
                .replace(":businessarea", dataSet.businessAreaName.toLowerCase())
                .replace(":schema", dataSet.schemaName)
                .replace(":dataSetId", dataSet.dataSetId)
                .replace(":dataSetAction", "view"),
        );
    };

    showEditDataSet = (dataSet) => {
        this.props.history.push(
            AppPaths.TENANT_SCHEMA_DATASET_ID_ACTION.replace(":tenant", this.props.tenant.toLowerCase())
                .replace(":businessarea", dataSet.businessAreaName.toLowerCase())
                .replace(":schema", dataSet.schemaName)
                .replace(":dataSetId", dataSet.dataSetId)
                .replace(":dataSetAction", "edit"),
        );
    };

    onDataSetSelected = (selectedDataSetId) => {
        this.setState({
            selectedDataSetId,
        });
        this.props.onDataSetSelected && this.props.onDataSetSelected(selectedDataSetId);
    };

    fetchingDataSets = () => {
        let isBusy = this.state.fetchingDataSets || this.state.fetchingPermission;
        return isBusy;
    };

    isBusy = () => {
        return this.state.busy || this.fetchingDataSets();
    };

    render() {
        return (
            <FlexContainerLayout
                header={
                    <>
                        <Title level={4} className="!mb-0">
                            Datasets
                        </Title>
                        {this.state.refreshingDataSets ? <Spin size="small" /> : null}
                    </>
                }
                headerClassName="items-center gap-2"
            >
                <LoadingOverlay busy={this.isBusy()} spinner message={this.state.busyMessage || "Please wait..."}></LoadingOverlay>
                {!this.fetchingDataSets() ? (
                    this.state.permissionDenied ? (
                        <ProhibitedArea></ProhibitedArea>
                    ) : (
                        <DataSetRecentList
                            dataSetList={this.props.recentDataSetListResult.Items}
                            onViewDataSet={this.showViewDataSet}
                            onEditDataSet={this.showEditDataSet}
                            onDataSetSelected={this.onDataSetSelected}
                            permission={this.props.permission}
                        ></DataSetRecentList>
                    )
                ) : (
                    <></>
                )}
            </FlexContainerLayout>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        recentDataSetListResult: state.dataSets.recentDataSetListResult,
        getRecentDataSetResult: state.dataSets.getRecentDataSetResult,
        getUserDataSetPermissionResult: state.dataSets.getUserDataSetPermissionResult,
        permission: state.dataSets.permission,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getRecentDataSet: () => dispatch(actions.getRecentDataSetRequest()),
        getUserDataSetPermission: () => dispatch(actions.getUserDataSetPermissionRequest()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DataSetHomeOverview));
